import React from "react";
import { useFormik } from "formik";
import * as Yup from "yup";
import { useNavigate } from "react-router-dom";
import {
  Form,
  FormGroup,
  Label,
  Input,
  Button,
  Row,
  Col,
  Container,
} from "reactstrap";
import { createVessel } from "../../api/VesselDetails/addVesselApi";

const validationSchema = Yup.object({
  Name: Yup.string().required("Name is required"),
  Flag: Yup.string().required("Flag is required"),
  IMO: Yup.string().required("IMO is required"),
  IMULA_Number: Yup.string().required("IMULA Number is required"),
  Call_Sign: Yup.string().required("Call Sign is required"),
  AIS_transponder_Class: Yup.string().required(
    "AIS Transponder Class is required"
  ),
  General_vessel_Type: Yup.string().required("Requreid"),
  Detailed_Vessel_Type: Yup.string().required("rea"),
  Categories: Yup.string().required("dsfs"),
  Service_Status: Yup.string().required("Service Status is required"),
  Port_of_registry: Yup.string().required("Port of Registry is required"),
  Year_Built: Yup.number()
    .positive("Must be a valid year")
    .required("Year Built is required"),
  License_Category: Yup.string().required("License Category is required"),
  National: Yup.string().required("National is required"),
  Registered_Date: Yup.date()
    .required("Registered Date is required")
    .typeError("Invalid date"),
  Breadth: Yup.number()
    .positive("Must be a positive number")
    .required("Breadth is required"),
  Height: Yup.number()
    .positive("Must be a positive number")
    .required("Height is required"),
  Fuel_Type: Yup.string().required("Fuel Type is required"),
  Engine_Type: Yup.string().required("Engine Type is required"),
  Fuel_Tank_Capacity: Yup.number()
    .positive("Must be a positive number")
    .required("Fuel Tank Capacity is required"),
  Hold_Capacity: Yup.number()
    .positive("Must be a positive number")
    .required("Hold Capacity is required"),
  Engine_Capacity: Yup.number()
    .positive("Must be a positive number")
    .required("Engine Capacity is required"),
  Fuel_Consumption: Yup.number()
    .positive("Must be a positive number")
    .required("Fuel Consumption is required"),
  Fishing_Methods: Yup.string().required("Fishing Methods are required"),
  Hull_Material: Yup.string().required("Hull Material is required"),
  Owner_Name: Yup.string().required("Owner Name is required"),
  Owner_Address: Yup.string().required("Owner Address is required"),
});

const VesselForm = () => {
  const navigate = useNavigate();

  const formik = useFormik({
    initialValues: {
      Name: "",
      Flag: "",
      IMO: "",
      IMULA_Number: "",
      Call_Sign: "",
      AIS_transponder_Class: "",
      General_vessel_Type: "",
      Detailed_Vessel_Type: "",
      Categories: "",
      Service_Status: "",
      Port_of_registry: "",
      Year_Built: "",
      License_Category: "",
      National: "",
      Registered_Date: "",
      Breadth: "",
      Height: "",
      Fuel_Type: "",
      Engine_Type: "",
      Fuel_Tank_Capacity: "",
      Hold_Capacity: "",
      Engine_Capacity: "",
      Fuel_Consumption: "",
      Fishing_Methods: "",
      Hull_Material: "",
      Owner_Name: "",
      Owner_Address: "",
    },
    validationSchema,
    onSubmit: async (values) => {
      alert("heello");
      try {
        const response = await createVessel(values);
        console.log("Form submitted successfully:", response.data);
      } catch (error) {
        console.error("Error submitting form:", error);
      }
    },
  });

  return (
    <React.Fragment>
      <Container className="py-4">
        <Form
          onSubmit={formik.handleSubmit}
          className="p-4 border rounded shadow-sm"
        >
          <Row>
            <Col md={6}>
              <FormGroup>
                <Label for="Name">Name</Label>
                <Input
                  id="Name"
                  name="Name"
                  type="text"
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={formik.values.Name}
                  invalid={!!(formik.touched.Name && formik.errors.Name)}
                />
                {formik.touched.Name && formik.errors.Name && (
                  <div className="text-danger small">{formik.errors.Name}</div>
                )}
              </FormGroup>
            </Col>
            <Col md={6}>
              <FormGroup>
                <Label for="Flag">Flag</Label>
                <Input
                  id="Flag"
                  name="Flag"
                  type="text"
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={formik.values.Flag}
                  invalid={!!(formik.touched.Flag && formik.errors.Flag)}
                />
                {formik.touched.Flag && formik.errors.Flag && (
                  <div className="text-danger small">{formik.errors.Flag}</div>
                )}
              </FormGroup>
            </Col>
            <Col md={6}>
              <FormGroup>
                <Label for="IMO">IMO</Label>
                <Input
                  id="IMO"
                  name="IMO"
                  type="number"
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={formik.values.IMO}
                  invalid={!!(formik.touched.IMO && formik.errors.IMO)}
                />
                {formik.touched.IMO && formik.errors.IMO && (
                  <div className="text-danger small">{formik.errors.IMO}</div>
                )}
              </FormGroup>
            </Col>
            <Col md={6}>
              <FormGroup>
                <Label for="IMULA Number">IMULA Number</Label>
                <Input
                  id="IMULA_Number"
                  name="IMULA_Number"
                  type="text"
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={formik.values.IMULA_Number}
                  invalid={
                    !!(
                      formik.touched.IMULA_Number && formik.errors.IMULA_Number
                    )
                  }
                />
                {formik.touched.IMULA_Number && formik.errors.IMULA_Number && (
                  <div className="text-danger small">
                    {formik.errors.IMULA_Number}
                  </div>
                )}
              </FormGroup>
            </Col>
            <Col md={6}>
              <FormGroup>
                <Label for="Call Sign">Call Sign</Label>
                <Input
                  id="Call_Sign"
                  name="Call_Sign"
                  type="text"
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={formik.values.Call_Sign}
                  invalid={
                    !!(formik.touched.Call_Sign && formik.errors.Call_Sign)
                  }
                />
                {formik.touched.Call_Sign && formik.errors.Call_Sign && (
                  <div className="text-danger small">
                    {formik.errors.Call_Sign}
                  </div>
                )}
              </FormGroup>
            </Col>
            <Col md={6}>
              <FormGroup>
                <Label for="AIS transponder Class">AIS transponder Class</Label>
                <Input
                  id="AIS_transponder_Class"
                  name="AIS_transponder_Class"
                  type="text"
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={formik.values.AIS_transponder_Class}
                  invalid={
                    !!(
                      formik.touched.AIS_transponder_Class &&
                      formik.errors.AIS_transponder_Class
                    )
                  }
                />
                {formik.touched.AIS_transponder_Class &&
                  formik.errors.AIS_transponder_Class && (
                    <div className="text-danger small">
                      {formik.errors.AIS_transponder_Class}
                    </div>
                  )}
              </FormGroup>
            </Col>
            <Col md={6}>
              <FormGroup>
                <Label for="General vessel Type">General vessel Type</Label>
                <Input
                  id="General_vessel_Type"
                  name="General_vessel_Type"
                  type="text"
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={formik.values.Flag}
                  invalid={
                    !!(
                      formik.touched.General_vessel_Type &&
                      formik.errors.General_vessel_Type
                    )
                  }
                />
                {formik.touched.General_vessel_Type &&
                  formik.errors.General_vessel_Type && (
                    <div className="text-danger small">
                      {formik.errors.General_vessel_Type}
                    </div>
                  )}
              </FormGroup>
            </Col>
            <Col md={6}>
              <FormGroup>
                <Label for="Detailed Vessel Type">Detailed Vessel Type</Label>
                <Input
                  id="Detailed_Vessel_Type"
                  name="Detailed_Vessel_Type"
                  type="text"
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={formik.values.Detailed_Vessel_Type}
                  invalid={
                    !!(
                      formik.touched.Detailed_Vessel_Type &&
                      formik.errors.Detailed_Vessel_Type
                    )
                  }
                />
                {formik.touched.Detailed_Vessel_Type &&
                  formik.errors.Detailed_Vessel_Type && (
                    <div className="text-danger small">
                      {formik.errors.Detailed_Vessel_Type}
                    </div>
                  )}
              </FormGroup>
            </Col>
            <Col md={6}>
              <FormGroup>
                <Label for="Categories">Categories</Label>
                <Input
                  id="Categories"
                  name="Categories"
                  type="text"
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={formik.values.Categories}
                  invalid={
                    !!(formik.touched.Categories && formik.errors.Categories)
                  }
                />
                {formik.touched.Categories && formik.errors.Categories && (
                  <div className="text-danger small">
                    {formik.errors.Categories}
                  </div>
                )}
              </FormGroup>
            </Col>
            <Col md={6}>
              <FormGroup>
                <Label for="Service Status">Service Status</Label>
                <Input
                  id="Service_Status"
                  name="Service_Status"
                  type="text"
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={formik.values.Service_Status}
                  invalid={
                    !!(
                      formik.touched.Service_Status &&
                      formik.errors.Service_Status
                    )
                  }
                />
                {formik.touched.Service_Status &&
                  formik.errors.Service_Status && (
                    <div className="text-danger small">
                      {formik.errors.Service_Status}
                    </div>
                  )}
              </FormGroup>
            </Col>
            <Col md={6}>
              <FormGroup>
                <Label for="Port of registry">Port of registry</Label>
                <Input
                  id="Port_of_registry"
                  name="Port_of_registry"
                  type="text"
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={formik.values.Port_of_registry}
                  invalid={
                    !!(
                      formik.touched.Port_of_registry &&
                      formik.errors.Port_of_registry
                    )
                  }
                />
                {formik.touched.Port_of_registry &&
                  formik.errors.Port_of_registry && (
                    <div className="text-danger small">
                      {formik.errors.Port_of_registry}
                    </div>
                  )}
              </FormGroup>
            </Col>
            <Col md={6}>
              <FormGroup>
                <Label for="Year Built">Year Built</Label>
                <Input
                  id="Year_Built"
                  name="Year_Built"
                  type="text"
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={formik.values.Year_Built}
                  invalid={
                    !!(formik.touched.Year_Built && formik.errors.Year_Built)
                  }
                />
                {formik.touched.Year_Built && formik.errors.Year_Built && (
                  <div className="text-danger small">
                    {formik.errors.Year_Built}
                  </div>
                )}
              </FormGroup>
            </Col>
            <Col md={6}>
              <FormGroup>
                <Label for="License Category">License Category</Label>
                <Input
                  id="License_Category"
                  name="License_Category"
                  type="text"
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={formik.values.License_Category}
                  invalid={
                    !!(
                      formik.touched.License_Category &&
                      formik.errors.License_Category
                    )
                  }
                />
                {formik.touched.License_Category &&
                  formik.errors.License_Category && (
                    <div className="text-danger small">
                      {formik.errors.License_Category}
                    </div>
                  )}
              </FormGroup>
            </Col>
            <Col md={6}>
              <FormGroup>
                <Label for="National">National</Label>
                <Input
                  id="National"
                  name="National"
                  type="text"
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={formik.values.National}
                  invalid={
                    !!(formik.touched.National && formik.errors.National)
                  }
                />
                {formik.touched.National && formik.errors.National && (
                  <div className="text-danger small">
                    {formik.errors.National}
                  </div>
                )}
              </FormGroup>
            </Col>
            <Col md={6}>
              <FormGroup>
                <Label for="Registered_Date">Registered Date</Label>
                <Input
                  id="Registered_Date"
                  name="Registered_Date"
                  type="text"
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={formik.values.Registered_Date}
                  invalid={
                    !!(
                      formik.touched.Registered_Date &&
                      formik.errors.Registered_Date
                    )
                  }
                />
                {formik.touched.Registered_Date &&
                  formik.errors.Registered_Date && (
                    <div className="text-danger small">
                      {formik.errors.Registered_Date}
                    </div>
                  )}
              </FormGroup>
            </Col>
            <Col md={6}>
              <FormGroup>
                <Label for="Breadth">Breadth</Label>
                <Input
                  id="Breadth"
                  name="Breadth"
                  type="text"
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={formik.values.Breadth}
                  invalid={!!(formik.touched.Breadth && formik.errors.Breadth)}
                />
                {formik.touched.Breadth && formik.errors.Breadth && (
                  <div className="text-danger small">
                    {formik.errors.Breadth}
                  </div>
                )}
              </FormGroup>
            </Col>
            <Col md={6}>
              <FormGroup>
                <Label for="Height">Height</Label>
                <Input
                  id="Height"
                  name="Height"
                  type="text"
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={formik.values.Height}
                  invalid={!!(formik.touched.Height && formik.errors.Height)}
                />
                {formik.touched.Height && formik.errors.Height && (
                  <div className="text-danger small">
                    {formik.errors.Height}
                  </div>
                )}
              </FormGroup>
            </Col>
            <Col md={6}>
              <FormGroup>
                <Label for="Fuel_Type">Fuel Type</Label>
                <Input
                  id="Fuel_Type"
                  name="Fuel_Type"
                  type="text"
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={formik.values.Fuel_Type}
                  invalid={
                    !!(formik.touched.Fuel_Type && formik.errors.Fuel_Type)
                  }
                />
                {formik.touched.Fuel_Type && formik.errors.Fuel_Type && (
                  <div className="text-danger small">
                    {formik.errors.Fuel_Type}
                  </div>
                )}
              </FormGroup>
            </Col>
            <Col md={6}>
              <FormGroup>
                <Label for="Engine Type">Engine Type</Label>
                <Input
                  id="Engine_Type"
                  name="Engine_Type"
                  type="text"
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={formik.values.Engine_Type}
                  invalid={
                    !!(formik.touched.Engine_Type && formik.errors.Engine_Type)
                  }
                />
                {formik.touched.Engine_Type && formik.errors.Engine_Type && (
                  <div className="text-danger small">
                    {formik.errors.Engine_Type}
                  </div>
                )}
              </FormGroup>
            </Col>
            <Col md={6}>
              <FormGroup>
                <Label for="Fuel Tank Capacity">Fuel Tank Capacity</Label>
                <Input
                  id="Fuel_Tank_Capacity"
                  name="Fuel_Tank_Capacity"
                  type="text"
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={formik.values.Fuel_Tank_Capacity}
                  invalid={
                    !!(
                      formik.touched.Fuel_Tank_Capacity &&
                      formik.errors.Fuel_Tank_Capacity
                    )
                  }
                />
                {formik.touched.Fuel_Tank_Capacity &&
                  formik.errors.Fuel_Tank_Capacity && (
                    <div className="text-danger small">
                      {formik.errors.Fuel_Tank_Capacity}
                    </div>
                  )}
              </FormGroup>
            </Col>
            <Col md={6}>
              <FormGroup>
                <Label for="Hold Capacity">Hold Capacity</Label>
                <Input
                  id="Hold_Capacity"
                  name="Hold_Capacity"
                  type="text"
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={formik.values.Hold_Capacity}
                  invalid={
                    !!(
                      formik.touched.Hold_Capacity &&
                      formik.errors.Hold_Capacity
                    )
                  }
                />
                {formik.touched.Hold_Capacity &&
                  formik.errors.Hold_Capacity && (
                    <div className="text-danger small">
                      {formik.errors.Hold_Capacity}
                    </div>
                  )}
              </FormGroup>
            </Col>
            <Col md={6}>
              <FormGroup>
                <Label for="Engine Capacity">Engine Capacity</Label>
                <Input
                  id="Engine_Capacity"
                  name="Engine_Capacity"
                  type="text"
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={formik.values.Engine_Capacity}
                  invalid={
                    !!(
                      formik.touched.Engine_Capacity &&
                      formik.errors.Engine_Capacity
                    )
                  }
                />
                {formik.touched.Engine_Capacity &&
                  formik.errors.Engine_Capacity && (
                    <div className="text-danger small">
                      {formik.errors.Engine_Capacity}
                    </div>
                  )}
              </FormGroup>
            </Col>
            <Col md={6}>
              <FormGroup>
                <Label for="Fuel Consumption">Fuel Consumption</Label>
                <Input
                  id="Fuel_Consumption"
                  name="Fuel_Consumption"
                  type="text"
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={formik.values.Fuel_Consumption}
                  invalid={
                    !!(
                      formik.touched.Fuel_Consumption &&
                      formik.errors.Fuel_Consumption
                    )
                  }
                />
                {formik.touched.Fuel_Consumption &&
                  formik.errors.Fuel_Consumption && (
                    <div className="text-danger small">
                      {formik.errors.Fuel_Consumption}
                    </div>
                  )}
              </FormGroup>
              Stock
            </Col>
            <Col md={6}>
              <FormGroup>
                <Label for="Fishing Mehthods">Fishing </Label>
                <Input
                  id="Fishing_Methods"
                  name="Fishing_Methods"
                  type="text"
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={formik.values.Fishing_Methods}
                  invalid={
                    !!(
                      formik.touched.Fishing_Methods &&
                      formik.errors.Fishing_Methods
                    )
                  }
                />
                {formik.touched.Fishing_Methods &&
                  formik.errors.Fishing_Methods && (
                    <div className="text-danger small">
                      {formik.errors.Fishing_Methods}
                    </div>
                  )}
              </FormGroup>
            </Col>
            <Col md={6}>
              <FormGroup>
                <Label for="Hull Material">Hull Material</Label>
                <Input
                  id="Hull_Material"
                  name="Hull_Material"
                  type="text"
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={formik.values.Hull_Material}
                  invalid={
                    !!(
                      formik.touched.Hull_Material &&
                      formik.errors.Hull_Material
                    )
                  }
                />
                {formik.touched.Hull_Material &&
                  formik.errors.Hull_Material && (
                    <div className="text-danger small">
                      {formik.errors.Hull_Material}
                    </div>
                  )}
              </FormGroup>
            </Col>
            <Col md={6}>
              <FormGroup>
                <Label for="Owner Name">Owner Name </Label>
                <Input
                  id="Owner_Name"
                  name="Owner_Name"
                  type="text"
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={formik.values.Owner_Name}
                  invalid={
                    !!(formik.touched.Owner_Name && formik.errors.Owner_Name)
                  }
                />
                {formik.touched.Owner_Name && formik.errors.Owner_Name && (
                  <div className="text-danger small">
                    {formik.errors.Owner_Name}
                  </div>
                )}
              </FormGroup>
            </Col>
            <Col md={6}>
              <FormGroup>
                <Label for="Owner Address">Owner_Address </Label>
                <Input
                  id="Owner_Address"
                  name="Owner_Address"
                  type="text"
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={formik.values.Owner_Address}
                  invalid={
                    !!(
                      formik.touched.Owner_Address &&
                      formik.errors.Owner_Address
                    )
                  }
                />
                {formik.touched.Owner_Address &&
                  formik.errors.Owner_Address && (
                    <div className="text-danger small">
                      {formik.errors.Owner_Address}
                    </div>
                  )}
              </FormGroup>
            </Col>
            <div className="text-end">
              <Button
                onClick={() => navigate("/previousPage")}
                style={{ marginRight: "1%" }}
              >
                Back
              </Button>
              <Button type="submit">Submit</Button>
            </div>
          </Row>
        </Form>
      </Container>
    </React.Fragment>
  );
};
export default VesselForm;
